export default __webpack_public_path__ + "static/media/deniseyap.11887318.jpg";